import { useEffect, useState } from 'react';

export default function useScrollOffset() {
  const [offset, setOffset] = useState();

  useEffect(() => {
    function handleScroll() {
      setOffset(window.pageYOffset);
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return offset;
}
